module.exports = __webpack_public_path__ + "img/law4m.2574102a.webp";